module.exports = __webpack_public_path__ + "static/img/HK-TF.5998ad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HK-TF.png
// module id = srmB
// module chunks = 1